import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { NotificationAction } from '../../app/common/notifications/notificationsActionType';
import { IReduxRootState } from '../../app/reduxRootState.interface';
import { IdentityVerification } from './IdentityVerification';
import IdentityVerificationActions from './identityVerificationActions';
import { IdentityVerificationAction } from './identityVerificationActionType';

function mapStateToProps(state: IReduxRootState) {
    return {
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.EKYC
            : '',
        ekycHelpPageUrl: state.app.clientConfig.ekycHelpPageUrl,
        isOverlayOpen: state.identityVerification.overlayOpen,
        isReady: state.app.memberLoggedIn,
        locale: state.app.locale,
        member: state.member,
        linkedServices: state.identityVerification.linkedServices,
        loadingLinkedServices: state.identityVerification.loadingLinkedServices,
    };
}

function mapDispatchToProps(
    dispatch: ThunkDispatch<IReduxRootState, {}, IdentityVerificationAction | NotificationAction>,
) {
    return {
        getLinkedServices: () => {
            dispatch(IdentityVerificationActions.getLinkedServices());
        },
        closeIdentityVerificationOverlay: () =>
            dispatch(IdentityVerificationActions.closeIdentityVerificationOverlay()),
        openIdentityVerificationOverlay: () =>
            dispatch(IdentityVerificationActions.openIdentityVerificationOverlay()),
    };
}

const IdentityVerificationContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(IdentityVerification);

export default IdentityVerificationContainer;
